/**
 * Laravel mengirim galat validasi sebagai { kolom: ["pesan", ...] }.
 * Form menampilkan {{ errors.kolom }} langsung, sehingga yang muncul
 * adalah teks mentah seperti [ "Nama wajib diisi." ]. Ambil pesan pertama saja.
 */
export function ratakanGalat(galat) {
  if (!galat || typeof galat !== 'object') return {};
  return Object.fromEntries(
    Object.entries(galat).map(([kolom, isi]) => [kolom, Array.isArray(isi) ? isi[0] : isi]),
  );
}
